import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Element, Link, scroller } from 'react-scroll';
import get from 'lodash/get';
import Helmet from 'react-helmet';

// Containers
import FacebookTestimonialsContainer from '../../containers/FacebookTestimonialsContainer/FacebookTestimonialsContainer';
import RealtorLandingContactForm from '../../containers/RealtorLandingContactForm/RealtorLandingContactForm';
import { getFormattedRealtorPackagePeriods } from '../../containers/RealtorPackagesContainer/packagesConfigs';

// Components
import Modal from '../Modal/Modal';
import NavTabs from '../StatefulTabs/NavTabs';
import LandingSliderPhoto from '../LandingSliderPhoto/LandingSliderPhoto';
import LogosCarousel from '../LandingLogosCarousel/LandingLogosCarousel';
import ReviewSites from '../ReviewSites/ReviewSites';
import ArticlesRead from '../ArticlesRead/ArticlesRead';

// Helpers
import { shareUrl } from '../../constants';
import scrollToUtil from '../../utils/scrollTo';
import multiLanguageTags from '../../helpers/multiLanguageHeadTags';

// styles
import * as styles from './RealtorLanding.scss';
import icons from '../../../static/icons/realtorLanding';
import heart from '../../../static/images/heart.png';
import images from '../../../static/images/RealtorLanding';
import RealtorLandingContactFormModal
  from '../../containers/RealtorLandingContactForm/RealtorLandingContactFormModal';

scroller.scrollTo = scrollToUtil.bind(scroller);

const promo = ['autojump', 'highlight', 'top'];
const manufacturer = [
  {
    price: '400,000+',
    description: 'medium'
  },
  {
    price: '1,000,000+',
    description: 'large'
  },
  {
    price: '50,000+',
    description: 'small'
  }
];

class RealtorLanding extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: false,
      defaultPackageMessage: '',
      formattedPackagePeriods: getFormattedRealtorPackagePeriods(props.translate),
      isCalculator: false
    };
  }

  componentWillUnmount() {
    document.body.style.overflow = '';
  }

  getPackageMessage = (packageInstance) => {
    const { packagesTranslate: translate } = this.props;
    const packageName = translate(packageInstance.packageNameKey).toString();
    const period = translate(packageInstance.currentPeriodKey).toString();
    const message = translate('defaultMessage').toString();

    return message.replace(/%plan%/, packageName).replace(/%period%/, period);
  };

  scrollToForm = () => this.scrollTo('realtor-landing-contact-us');
  scrollToPricing = () => this.scrollTo('realtor-landing-pricing-block');
  handleClickСommunity = () => this.scrollTo('realtor-landing-contact-us');

  scrollTo = (name) => scroller.scrollTo(name, {
    duration: 500,
    offset: this.props.isMobile ? -90 : -150,
    smooth: true
  });

  closeFormModal = () => {
    this.setState({ isModalOpen: false, defaultPackageMessage: '' });
    this.props.hideContactFormModal();
  };

  handleChoosePackage = (packageInstance) => {
    const message = this.getPackageMessage(packageInstance);
    this.setState({ isModalOpen: true, defaultPackageMessage: message });
    this.props.openContactFormModal();
  };

  renderPromoItem = (item) => (
    <div className={styles.featureItem} key={item}>
      <div className={cx(styles.featureImage, styles.promoImage)}><img src={get(icons[item], 'webp') || get(icons[item], 'fallback')} alt="" /></div>
      <div className={styles.featureTitle}>{this.props.translate(`${item}Title`)}</div>
      <div className={styles.featureDescription}>{this.props.translate(`${item}Description`)}</div>
    </div>
  );

  renderManufacturerItem = (item) => (
    <div className={styles.manufacturerItem} key={item.price}>
      <p>{item.price}</p>
      <p>{this.props.translate('manufacturer', item.description)}</p>
    </div>
  );

  render() {
    const { route, locale } = this.props;
    const multiLanguage = multiLanguageTags(route, locale);

    return (
      <div className={styles.pageWrapper}>
        <Helmet
          titleTemplate={this.props.rootTranslate('title', 'titleTemplate')()}
          title={this.props.translate('pageTitleSeo')()}
          meta={[
            { property: 'og:url', content: `${shareUrl}${route}` },
            { property: 'og:title', content: `${this.props.translate('pageTitleSeo')()} | \u202BOnMap` },
            { property: 'og:description', content: this.props.translate('pageDescriptionSeo') },
            { name: 'description', content: this.props.translate('pageDescriptionSeo') },
            { property: 'x:title', content: `${this.props.translate('pageTitleSeo')()} | \u202BOnMap` },
            { property: 'x:description', content: this.props.translate('pageDescriptionSeo') },
            { property: 'x:image:alt', content: this.props.translate('pageTitle') }
          ]}
          link={[
            ...multiLanguage,
            { rel: 'canonical', href: `${shareUrl}${route}` }
          ]}
        />
          <div className={styles.aboutUsContainer}>
            <h1 className={styles.aboutUsTitleMobile}>{this.props.translate('pageTitle')}</h1>
            <div className={styles.aboutUsImage}>
              <img src={images.aboutUsImage} alt="realtor" />
            </div>
            <div className={styles.aboutUsContent}>
              <h1 className={styles.aboutUsTitleDesktop}>{this.props.translate('pageTitle')}</h1>
              <p>{this.props.translate('pageDescription')}</p>
              <Link
                to="realtor-landing-contact-us"
                offset={this.props.isMobile ? -100 : -150}
                className={styles.link}
                smooth
              >
                <p>
                  {this.props.translate('joinOnline')}
                </p>
              </Link>
            </div>
          </div>
          <NavTabs
            translate={this.props.translate}
          />
          <div className={styles.aboutLeadsContainer}>
            <p className={styles.aboutLeadsTitleTablet}>
              {this.props.translate('aboutLeads', 'title')}
            </p>
            <img src={images.aboutLeads} alt="realtor" />
            <div className={styles.aboutLeadsText}>
              <p className={styles.aboutLeadsTitleDesktop}>
                {this.props.translate('aboutLeads', 'title')}
              </p>
              <p>{this.props.translate('aboutLeads', 'foreword')}</p>
              <p>{this.props.translate('aboutLeads', 'blockValue')}</p>
            </div>
          </div>
          <div className={styles.carouselPhoto}>
            <div className={styles.title}>
              <p>{this.props.translate('carouselPhoto', 'title')}</p>
            </div>
            <LandingSliderPhoto isMobile={this.props.isMobile} isRtl={this.props.isRtl} />
          </div>
          <div className={styles.promoContainer}>
            <div className={styles.promoWrapper}>
              <p>{this.props.translate('promo', 'title')}</p>
              <div className={styles.promoItems}>{promo.map(this.renderPromoItem)}</div>
            </div>
            <p className={styles.reminder}>
              {this.props.translate('promo', 'reminder')}
            </p>
          </div>
          <div className={styles.manufacturerContainer}>
            <div className={styles.manufacturerWrapper}>
              <p className={styles.manufacturerTitle}>
                {this.props.translate('manufacturer', 'title')}
              </p>
              <div className={styles.manufacturerInfoWrapper}>
                <div className={styles.manufacturerItemWrapper}>
                  {manufacturer.map(this.renderManufacturerItem)}
                </div>
              </div>
            </div>
          </div>
          {/* <div className={styles.packagesContainer} name="realtor-landing-pricing-block">
            <RealtorPackageWrapper
              handleChoosePackage={this.handleChoosePackage}
              translate={this.props.translate}
              isRtl={this.props.isRtl}
              rootTranslate={this.props.rootTranslate}
              openMessageModal={this.props.openMessageModal}
              locale={this.props.locale}
              hideMessageModal={this.props.hideMessageModal}
            />
          </div> */}
          <div className={styles.communityContainer}>
            <p className={styles.communityTitle}>
              {this.props.translate('community', 'title')}
            </p>
            <p>
              {this.props.translate('community', 'foreword')}
            </p>
            <div className={styles.communitybuttonWrapper}>
              <img src={heart} className={styles.heart} alt="" />
              <button
                onClick={this.handleClickСommunity}
              >
                {this.props.translate('community', 'buttonText')}
              </button>
            </div>
            <LogosCarousel />
            <p>
              {this.props.translate('community', 'blockValue')}
            </p>
            <div className={styles.partnerLogo}>
              <img src={images.partnerLogo} alt="realtor" />
            </div>
          </div>
        <div className={styles.testimonialsWrapper}>
          <FacebookTestimonialsContainer />
        </div>
        <div className={styles.reviewSitesContainer}>
          <ReviewSites
            translate={this.props.translate}
          />
        </div>
        {!this.state.isModalOpen &&
          <div
            className={styles.feedbackBlock}
            name="realtor-landing-contact-us"
          >
            <Element>
              <RealtorLandingContactForm />
            </Element>
          </div>
        }
        <div className={styles.articlesReadWrapper}>
          <ArticlesRead
            locale={this.props.locale}
            translate={this.props.translate}
          />
        </div>
        {/* <div
          className={styles.letterSubscription}
        >
          <Element>
            <LetterSubscriptionForm />
          </Element>
        </div> */}
        <Modal
          className="contactUsModal"
          isOpen={this.state.isModalOpen}
          onRequestClose={this.closeFormModal}
          translate={this.props.translate}
          isRtl={this.props.isRtl}
          withoutTitle
        >
          <RealtorLandingContactFormModal
            inModal
            formModalIsOpen={this.state.isModalOpen}
            handleRequest={this.closeFormModal}
            initialValues={{ message: this.state.defaultPackageMessage }}
          />
        </Modal>
      </div>
    );
  }
}

RealtorLanding.propTypes = {
  translate: PropTypes.func,
  rootTranslate: PropTypes.func,
  packagesTranslate: PropTypes.func,
  openMessageModal: PropTypes.func,
  hideMessageModal: PropTypes.func,
  openContactFormModal: PropTypes.func,
  hideContactFormModal: PropTypes.func,
  locale: PropTypes.string,
  isMobile: PropTypes.bool,
  isRtl: PropTypes.bool,
  route: PropTypes.any
};

export default RealtorLanding;
